module.exports = __webpack_public_path__ + "static/ourwork-private-event-18350fb98c3be24168a59807a88b62b3.jpg";